import { useState } from 'react';
import PackCardQuietStack from './PackCardQuietStack.jsx';
import { useMediaQuery } from '../../hooks/useMediaQuery.js';

const LEAD_PACK_IDS = ['italian-weeknights', 'spanish-weeknights', 'healthy-weeknights'];
const WIDE_ROW = 3;

function orderOnboardingPacks(packs) {
  const list = Array.isArray(packs) ? packs : [];
  const byId = new Map(list.map((pack) => [pack.id, pack]));
  const lead = LEAD_PACK_IDS.map((id) => byId.get(id)).filter(Boolean);
  const leadIds = new Set(lead.map((pack) => pack.id));
  const rest = list.filter((pack) => !leadIds.has(pack.id));
  return lead.length ? [...lead, ...rest] : list;
}

/**
 * Setup Recipes lead: page title, one row of packs, then more rows on request.
 */
export default function OnboardingRecipesAdd({ packs, addedPackIds, onOpenPack, onAddPack }) {
  const ordered = orderOnboardingPacks(packs);
  const [expanded, setExpanded] = useState(false);
  const phone = useMediaQuery('(max-width: 620px)');
  const mid = useMediaQuery('(max-width: 900px)');
  const perRow = phone ? 1 : mid ? 2 : WIDE_ROW;
  const visible = expanded ? ordered : ordered.slice(0, perRow);
  const canExpand = ordered.length > perRow;

  return (
    <div className="onboarding-recipes">
      <h1 className="onboarding-recipes__title">Add recipes you'd like to cook.</h1>
      <h2 className="onboarding-recipes__section">Try some of our favorites.</h2>
      <div className="onboarding-packs__grid">
        {visible.map((pack) => {
          const added = Boolean(addedPackIds?.has(pack.id) || (pack.slug && addedPackIds?.has(pack.slug)));
          return (
            <PackCardQuietStack
              key={pack.id}
              pack={pack}
              added={added}
              onOpen={() => onOpenPack?.(pack.id)}
              onAdd={onAddPack}
            />
          );
        })}
      </div>
      {canExpand ? (
        <button
          type="button"
          className="onboarding-packs__more"
          aria-expanded={expanded}
          onClick={() => setExpanded((open) => !open)}
        >
          <span className="onboarding-packs__more-label">
            {expanded ? 'Show fewer packs' : 'See more packs'}
          </span>
          <i
            className={`fas fa-chevron-${expanded ? 'up' : 'down'}`}
            aria-hidden="true"
          />
        </button>
      ) : null}
    </div>
  );
}
